import { Table, Tag, Tooltip } from "antd";
import { truncateFloat } from "../../../../helpers/generalHelper";
import { trimSpaces } from "../../../../helpers/textTransform";
import { colorAreas } from "../../../../types/schemesColors";

export const columnsInfoPojectSimulation = (editAction, deleteAction) => {
    const props = { scroll: { x: "100%", y: null } };

    const columns = [
        {
            title: "Horas Presupuesto",
            dataIndex: "name",
            key: "name",
            render: (text) => <span className="w-24 block">{text}</span>,
        },
        {
            title: "Horas",
            dataIndex: "hrs",
            key: "hrs",
            render: (text) => <span>{text}</span>,
        },
    ];

    return {
        columns,
        props,
    };
};

const columnsTypeHrs = (editAction, deleteAction) => {
    return [
        {
            title: "Área",
            dataIndex: "name",
            key: "name",

            render: (text) => {
                let color = "#ccc";
                const colorSchema = colorAreas.find((col) => trimSpaces(col.name) === trimSpaces(text));
                if (colorSchema) {
                    color = colorSchema.color;
                }
                return (
                    <div className="flex items-center gap-2 w-40">
                        <div className="w-fit">
                            <div className="w-4 h-4 rounded-full" style={{ backgroundColor: color }}></div>
                        </div>
                        <span className="font-semibold text-xs">{text}</span>
                    </div>
                );
            },
        },
        {
            title: "Horas Presupuesto",
            dataIndex: "budget",
            key: "budget",
            render: (text) => <span className="w-32 block">{truncateFloat(text)}</span>,
        },
        {
            title: (text) => (
                <Tooltip title="Horas trabajadas + Assets + Proveedores aprobados">
                    <span>Horas Consumidas</span>
                </Tooltip>
            ),
            dataIndex: "hrsWork",
            key: "hrsWork",
            render: (text) => <span className="w-32 block">{truncateFloat(text)}</span>,
        },
        {
            title: (text) => (
                <Tooltip title="Hrs trabajadas + backlog (tiempo estimado) + Assets aprobados + Proveedores aprobados">
                    <span>Horas Proyección</span>
                </Tooltip>
            ),
            dataIndex: "projection",
            key: "projection",
            render: (text) => <span className="w-28 block">{truncateFloat(text)} </span>,
        },
        {
            title: "Horas Assets Simulación",
            dataIndex: "hrsAssets",
            key: "hrsAssets",
            className: "bg-[#4385f5] text-white border-y border-white",
            render: (text) => <span className="w-32 block">{truncateFloat(text)}</span>,
        },
        {
            title: "Horas Proveedores Simulación",
            dataIndex: "hrsProvider",
            key: "hrsProvider",
            className: "bg-[#4385f5] text-white border-y border-white",
            render: (text) => <span className="w-32 block">{truncateFloat(text)}</span>,
        },
        {
            title: "Horas Restantes",
            dataIndex: "hrsRemaining",
            key: "hrsRemaining",
            render: (text) => {
                let color = "#00000033";
                if (text < 0) {
                    color = "red";
                }
                if (text >= 0) {
                    color = "green";
                }
                return (
                    <div className="w-32 block">
                        <Tag color={color} className="min-w-16 text-center text-black">
                            {truncateFloat(text)}
                        </Tag>
                    </div>
                );
            },
        },
    ];
};

export const columnsInfoPojectHrsSimulation = (editAction, deleteAction) => {
    const columns = columnsTypeHrs(editAction, deleteAction);
    const props = {
        scroll: { x: "100%", y: null },
        className: "simulationTable",
        summary: (record) => {
            if (!record) return;
            if (record.length === 0) return;
            const summary = record.reduce(
                (total, { budget = 0, hrsWork = 0, projection = 0, hrsAssets = 0, hrsProvider = 0, hrsRemaining = 0 }) => {
                    total.budget += budget;
                    total.hrsWork += hrsWork;
                    total.projection += projection;
                    total.hrsAssets += hrsAssets;
                    total.hrsProvider += hrsProvider;
                    total.hrsRemaing += hrsRemaining;
                    return total;
                },
                { budget: 0, hrsWork: 0, projection: 0, hrsAssets: 0, hrsProvider: 0, hrsRemaing: 0 }
            );
            const timeGeneralEstimated = record[0].hrsGlobalEstimated;
            const timeLeftGeneral = timeGeneralEstimated - summary.projection - summary.hrsAssets - summary.hrsProvider;

            return (
                <>
                    <Table.Summary.Row className="font-bold">
                        <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>{truncateFloat(summary.budget)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>{truncateFloat(summary.hrsWork)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>{truncateFloat(summary.projection)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={4}>{truncateFloat(summary.hrsAssets)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={5}>{truncateFloat(summary.hrsProvider)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>{truncateFloat(summary.hrsRemaing)}</Table.Summary.Cell>
                    </Table.Summary.Row>
                    <Table.Summary.Row className="font-bold">
                        <Table.Summary.Cell index={0}>Total general</Table.Summary.Cell>
                        <Table.Summary.Cell index={1}>{truncateFloat(record[0].hrsGlobalEstimated)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>{truncateFloat(summary.hrsWork)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={3}>{truncateFloat(summary.projection)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={4}>{truncateFloat(summary.hrsAssets)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={5}>{truncateFloat(summary.hrsProvider)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>{truncateFloat(timeLeftGeneral)}</Table.Summary.Cell>
                    </Table.Summary.Row>
                </>
            );
        },
    };
    return {
        columns,
        props,
    };
};
